import { useState } from "react";
import { useNavigate } from "react-router";
import { Scanner } from "../features/assets/Scanner";
import { api, ApiError } from "../lib/api";

interface QrHit {
  assetId: string;
  buildingId: string;
  code: string;
  name: string;
}

const lookup = (code: string) => api<QrHit>(`/assets/by-qr?code=${encodeURIComponent(code)}`);
const target = (h: QrHit) => `/gebouwen/${h.buildingId}?asset=${h.assetId}`;

/** QR-code scannen in de app: opent de asset in zijn gebouw. */
export function ScanPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [round, setRound] = useState(0);
  return (
    <div className="page scanpage">
      <p className="label">Assets</p>
      <h1 className="dot">QR-code scannen</h1>
      {error ? (
        <div className="stack">
          <div className="alert" role="alert">
            {error}
          </div>
          <div>
            <button
              type="button"
              className="btn primary"
              onClick={() => {
                setError(null);
                setRound(round + 1);
              }}
            >
              Opnieuw scannen
            </button>
          </div>
          <p className="muted small">
            Een nieuwe sticker koppel je via de asset: open de asset en kies “Bestaande sticker koppelen”.
          </p>
        </div>
      ) : (
        <Scanner
          key={round}
          hint="Richt de camera op de QR-code van een asset."
          onResult={(text) =>
            lookup(text).then(
              (h) => navigate(target(h)),
              (e: unknown) => setError(e instanceof ApiError ? e.message : "Opzoeken mislukt"),
            )
          }
        />
      )}
    </div>
  );
}
